var video_viewer_default = {
  "video_player": "hkrbc",
  "videoOverlay": "_3OwBl",
  "video_container": "CB1gp"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
